module.exports = __webpack_public_path__ + "img/Teens.e5af3156.svg";